import React from 'react'

import clsx from '@/utils/clsx'

const LIST_ADDRESS_TAB_ITEM = [
  { id: 'mien_bac', name: 'Miền Bắc' },
  { id: 'mien_trung', name: 'Miền Trung' },
  { id: 'mien_nam', name: 'Miền Nam' },
]

function AddressTab({ selectedTab, handleClick }) {
  return LIST_ADDRESS_TAB_ITEM.map(item => {
    const clsName = clsx({
      'footer-address-tab-item': true,
      active: selectedTab === item.id,
    })
    return (
      <div
        key={item.id}
        onClick={event => handleClick(event.target.id)}
        className={clsName}
      >
        <h3 id={item.id} className="footer-title-area">
          {item.name}
        </h3>
      </div>
    )
  })
}

function AddressTabContent({ selectedTab }) {
  if (selectedTab === 'mien_bac')
    return (
      <>
        <div className="footer-address-tab-pane active">
          <div className="province">
            <p className="province-name">Hà Nội:</p>
            <p className="province-detail">
              Số 1B Yết Kiêu, quận Hoàn Kiếm - 02 256 509 126
            </p>
          </div>
          <div className="province">
            <p className="province-name">Hải phòng:</p>
            <p className="province-detail">
              Số 176A Tôn Đức Thắng, quận Lê Chân. Hotline: 0912555888
            </p>
          </div>
          <div className="province">
            <p className="province-name">Quảng Ninh:</p>
            <p className="province-detail">
              Số 19 Cao Xanh, phường Cao Xanh, TP. Hạ Long - Hotline: 0912555888
            </p>
          </div>
          <div className="province">
            <p className="province-name">Hải Dương:</p>
            <p className="province-detail">
              Số 32 Hồng Quang, P.Quang Trung, TP Hải Dương - Hotline:
              0912555888
            </p>
          </div>
          <div className="province">
            <p className="province-name">Nam Định:</p>
            <p className="province-detail">
              Số 125 Hai Bà Trưng, TP. Nam Định. Hotline: 0981 374 268
            </p>
          </div>
          <div className="province">
            <p className="province-name">Thái Nguyên:</p>
            <p className="province-detail">
              Số 111 Lương Ngọc Quyến, TP. Thái Nguyên - Hotline: 0912555888
            </p>
          </div>
        </div>
        <div className="footer-address-tab-pane">
          <div className="province">
            <p className="province-name">Đà Nẵng:</p>
            <p className="province-detail">
              Số 223 Nguyễn Văn Linh, quận Thanh Khê Hotline: 02 366 523 966
            </p>
          </div>
          <div className="province">
            <p className="province-name">Khánh Hòa:</p>
            <p className="province-detail">
              Số 5B, Tòa nhà CT3, Khu đô thị VCN Phước Hải, TP. Nha Trang
              Hotline: 0901 903 866
            </p>
          </div>
          <div className="province">
            <p className="province-name">Nghệ An:</p>
            <p className="province-detail">
              341 Nguyễn Văn Cừ, TP VinhLong Hotline: 02 386 668 168
            </p>
          </div>
          <div className="province">
            <p className="province-name">Thừa Thiên Huế:</p>
            <p className="province-detail">
              Số 21 Phan Bội Châu, TP. Huế Hotline: 02 346 542 468
            </p>
          </div>
          <div className="province">
            <p className="province-name">Thanh Hóa:</p>
            <p className="province-detail">
              Lô 15 Đội Cung, Trường Thi, TP. Thanh Hóa Hotline: 02 376 546 688
            </p>
          </div>
          <div className="province">
            <p className="province-name">Bình Định:</p>
            <p className="province-detail">
              Số 136 Chương Dương, TP. Quy Nhơn - Hotline: 02 566 527 662
            </p>
          </div>
        </div>
        <div className="footer-address-tab-pane">
          <div className="province">
            <p className="province-name">TP.HCM:</p>
            <p className="province-detail">
              Tầng 6 – Khu C, Tòa nhà WASECO Số 10 Phổ Quang, quận Tân Bình
            </p>
          </div>
          <div className="province">
            <p className="province-name">Cần Thơ:</p>
            <p className="province-detail">
              Số 23 đường Trần Phú, P. Cái Khế, Q. Ninh Kiều, TP. Cần Thơ
              Hotline: 0292 6502 777
            </p>
          </div>
          <div className="province">
            <p className="province-name">Vũng Tàu:</p>
            <p className="province-detail">
              Số 17 Phạm Hồng Thái, TP. Vũng Tàu Hotline: 02 542 210 888
            </p>
          </div>
          <div className="province">
            <p className="province-name">Đồng Tháp:</p>
            <p className="province-detail">
              Số 05 Đặng Văn Bình, TP.Cao Lãnh, Tỉnh Đồng Tháp Hotline: 0277
              6277 666
            </p>
          </div>
          <div className="province">
            <p className="province-name">Cà Mau:</p>
            <p className="province-detail">
              Số 72 Lý Bôn, Phường 4, TP. Cà Mau Hotline: 0290 6269 696
            </p>
          </div>
          <div className="province">
            <p className="province-name">Tiền Giang:</p>
            <p className="province-detail">
              Số 39 Huyện Thoại, Phường 1, TP. Mỹ Tho Hotline: 02 736 567 567
            </p>
          </div>
        </div>
      </>
    )
  if (selectedTab === 'mien_trung')
    return (
      <>
        <div className="footer-address-tab-pane active">
          <div className="province">
            <p className="province-name">Đà Nẵng:</p>
            <p className="province-detail">
              Số 223 Nguyễn Văn Linh, quận Thanh Khê Hotline: 02 366 523 966
            </p>
          </div>
          <div className="province">
            <p className="province-name">Khánh Hòa:</p>
            <p className="province-detail">
              Số 5B, Tòa nhà CT3, Khu đô thị VCN Phước Hải, TP. Nha Trang
              Hotline: 0901 903 866
            </p>
          </div>
          <div className="province">
            <p className="province-name">Nghệ An:</p>
            <p className="province-detail">
              341 Nguyễn Văn Cừ, TP VinhLong Hotline: 02 386 668 168
            </p>
          </div>
          <div className="province">
            <p className="province-name">Thừa Thiên Huế:</p>
            <p className="province-detail">
              Số 21 Phan Bội Châu, TP. Huế Hotline: 02 346 542 468
            </p>
          </div>
          <div className="province">
            <p className="province-name">Thanh Hóa:</p>
            <p className="province-detail">
              Lô 15 Đội Cung, Trường Thi, TP. Thanh Hóa Hotline: 02 376 546 688
            </p>
          </div>
          <div className="province">
            <p className="province-name">Bình Định:</p>
            <p className="province-detail">
              Số 136 Chương Dương, TP. Quy Nhơn - Hotline: 02 566 527 662
            </p>
          </div>
        </div>
      </>
    )
  if (selectedTab === 'mien_nam')
    return (
      <>
        <div className="footer-address-tab-pane active">
          <div className="province">
            <p className="province-name">TP.HCM:</p>
            <p className="province-detail">
              Tầng 6 – Khu C, Tòa nhà WASECO Số 10 Phổ Quang, quận Tân Bình
            </p>
          </div>
          <div className="province">
            <p className="province-name">Cần Thơ:</p>
            <p className="province-detail">
              Số 23 đường Trần Phú, P. Cái Khế, Q. Ninh Kiều, TP. Cần Thơ
              Hotline: 0292 6502 777
            </p>
          </div>
          <div className="province">
            <p className="province-name">Vũng Tàu:</p>
            <p className="province-detail">
              Số 17 Phạm Hồng Thái, TP. Vũng Tàu Hotline: 02 542 210 888
            </p>
          </div>
          <div className="province">
            <p className="province-name">Đồng Tháp:</p>
            <p className="province-detail">
              Số 05 Đặng Văn Bình, TP.Cao Lãnh, Tỉnh Đồng Tháp Hotline: 0277
              6277 666
            </p>
          </div>
          <div className="province">
            <p className="province-name">Cà Mau:</p>
            <p className="province-detail">
              Số 72 Lý Bôn, Phường 4, TP. Cà Mau Hotline: 0290 6269 696
            </p>
          </div>
          <div className="province">
            <p className="province-name">Tiền Giang:</p>
            <p className="province-detail">
              Số 39 Huyện Thoại, Phường 1, TP. Mỹ Tho Hotline: 02 736 567 567
            </p>
          </div>
        </div>
      </>
    )
}

export default function MobileFooterAddress() {
  const [selectedTab, setSelectedTab] = React.useState(
    LIST_ADDRESS_TAB_ITEM[0].id,
  )
  const handleClick = value => {
    setSelectedTab(value)
    const line = document.getElementById('footer-address-line')

    const footerAddressTabActive = document.getElementById(value)
    line.style.left = footerAddressTabActive?.offsetLeft + 'px'
    line.style.width = footerAddressTabActive?.offsetWidth + 'px'
  }
  React.useEffect(() => {
    const line = document.getElementById('footer-address-line')
    const footerAddressTabActive = document.getElementsByClassName(
      'footer-address-tab-item active',
    )[0]
    line.style.left = footerAddressTabActive.offsetLeft + 'px'
    line.style.width = footerAddressTabActive.offsetWidth + 'px'
  }, [])
  return (
    <div className="footer-address-mobile">
      {/* <!-- Tab items --> */}
      <h3 className="footer-title">Địa chỉ</h3>
      <div className="footer-address-tabs">
        <AddressTab selectedTab={selectedTab} handleClick={handleClick} />
        <div id="footer-address-line" className="line"></div>
      </div>

      {/* <!-- Tab content --> */}
      <div className="footer-address-tab-content">
        <AddressTabContent selectedTab={selectedTab} />
      </div>
    </div>
  )
}
